import React, { useState, useEffect } from 'react';
import { Form, Input, Button, Alert, Select, Space } from 'antd';
import { connect } from 'react-redux';
import { logout, updateGlobalSearch, selectPage, requestServerPost, requestServerGet } from '../../actions';
import PopupManager from '../../managers/PopupManager';


const { Option } = Select;
const formItemLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
};
const formTailLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18, offset: 6 },
};

const CreateStreamingURLMediaView = (props) => {
    const [form] = Form.useForm();
    const [fileData, setFileData] = useState(null)
    const [errorMessage, setErrorMessage] = useState(null);
    const [initialV, setInitialV] = useState()
    const [subTypes, setSubTypes] = useState([]);
    const [selectedSubTypeID, setSelectedSubTypeID] = useState(1);
    const [accessBranches, setAccessBranches] = useState(["all"]);
    const { branches = [], allBranchesOption = true, initialAccessBranches = ["all"] } = props;

    useEffect(() => {
        if ("data" in props && props.data) {
            const type = props.data.FileType?.toLocaleLowerCase()

            if (type === "streamingurl") {

                const initial = {
                    medianame: props.data.FileName,
                    url: props.data.UploadFile,
                    type: subTypes.length ? subTypes[0].FileTypeSubID : null
                }

                form.setFieldsValue(initial)

                setFileData(props.data)
                setInitialV(initial)

                // Initialize accessBranches from existing media data
                const ab = props.data.AccessBranches;
                if (ab && ab !== "null" && ab !== "all" && ab !== "") {
                    setAccessBranches(ab.split(',').map(id => String(id).trim()).filter(Boolean));
                } else {
                    setAccessBranches(["all"]);
                }
            }

        }

        const { requestServerGet, usertoken } = props;
        console.log("requestServerGet")
        requestServerGet("get_filetypesub", { filetypeid: 4 }, { }, (response) => {

            console.log(response)
            setSubTypes(response.data)
        }, usertoken);
    }, [])

    // When branches load (async), apply the folder-based default in create mode
    useEffect(() => {
        if (!fileData) {
            setAccessBranches(initialAccessBranches);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [branches])

    function validURL(str) {
        var pattern = new RegExp('^(https?:\\/\\/)?' + // protocol
            '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
            '((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address
            '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' + // port and path
            '(\\?[;&a-z\\d%_.~+=-]*)?' + // query string
            '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator
        return !!pattern.test(str);
    }
    function validM3U8(str) {
        var pattern = new RegExp('^https?://.*\.m3u8$'); // fragment locator
        return !!pattern.test(str);
    }

    const onFinish = values => {

        const { requestServerPost, usertoken, selectedBrandData, selectedBranchData, data = null } = props;
        var params = {};

        const isURLValid = validURL(values.url)

        if (!isURLValid) {

        }
        params["brandid"] = selectedBrandData.BrandID;
        params["urlname"] = values.medianame;
        params["url"] = values.url;
        params["type"] = "StreamingURL";
        params["filetypeid"] = 4;
        params["filetypesubid"] = values.filetypesubid;
        params["accessbranches"] = accessBranches.includes("all") ? "all" : accessBranches.join(",");
        // When All Branches is hidden (folder-restricted), expand "all" to the explicit branch IDs
        if (!allBranchesOption && params["accessbranches"] === "all" && branches.length > 0) {
            params["accessbranches"] = branches.map(b => String(b.BranchID)).join(",");
        }
        if (selectedBrandData?.ContentSharingMode == 2 && selectedBranchData) {
            params["accessbranches"] = String(selectedBranchData.BranchID);
        }

        console.log(JSON.stringify(params))
        // return
        if (fileData) {
            params["fileid"] = fileData.FileID;
            requestServerPost("update_streamingurl", params, { }, (response) => {

                PopupManager.closePopup();
            }, usertoken);
        }
        else {
            requestServerPost("create_streamingurl", params, { }, (response) => {

                PopupManager.closePopup();
            }, usertoken);
        }
    };

    const onCreate = async () => {
        try {
            const values = await form.validateFields();
            // console.log('Success:', values);
        } catch (errorInfo) {
            // console.log('Failed:', errorInfo);
        }
    };

    const onURLChanged = (evt) => {
        const url = evt.target.value
        const isURLValid = validURL(url)
        const isM3U8Valid = validM3U8(url)

        if (!isURLValid) {
            setErrorMessage('The inputted URL might be invalid');
        }
        else if (!isM3U8Valid && (selectedSubTypeID == 1)) {
            setErrorMessage('The inputted URL is not a valid HLS URL');
        }
        else {
            setErrorMessage(null)
        }
    }
    const onTypeChanged = (typeID) => {
        console.log("type " + typeID)
        setSelectedSubTypeID(typeID)
    }

    const handleAccessBranchesChange = (value) => {
        let newVal;
        if (value.includes("all") && !accessBranches.includes("all")) {
            newVal = ["all"];
        } else if (accessBranches.includes("all") && value.length > 1) {
            newVal = value.filter(v => v !== "all");
        } else if (value.length === 0) {
            newVal = ["all"];
        } else {
            newVal = value;
        }
        setAccessBranches(newVal);
    };

    if (!subTypes.length)
        return null

    return (
        <Form form={form} initialValues={initialV} onFinish={onFinish} name="dynamic_rule" style={{ width: "100%" }}>
            <Form.Item

                {...formItemLayout}
                name="medianame"
                label="Stream Name"
                rules={[
                    {
                        required: true,
                        message: 'Stream name is required',
                    },
                ]}
            >
                <Input placeholder="Input the name of your stream" />
            </Form.Item>
            <Form.Item

                {...formItemLayout}
                name="filetypesubid"
                label="Type"
                initialValue={(subTypes.length > 0) ? subTypes[0].FileTypeSubID : null}
                rules={[
                    {
                        required: true,
                        message: 'Type is required',
                    },
                ]}
            >
                <Select
                    placeholder="Select type"

                    onSelect={onTypeChanged}
                    style={{
                        width: 200,
                    }}
                >
                    {subTypes.map((subtype => {
                        return <Option key={subtype.FileTypeSubID} value={subtype.FileTypeSubID}>{subtype.FileTypeSubDisplayName}</Option>
                    }))}

                </Select>
            </Form.Item>
            <Form.Item
                {...formItemLayout}
                name="url"
                label="URL"
                rules={[
                    {
                        required: true,
                        message: 'URL is required',
                    },
                ]}
            >
                <Input onChange={onURLChanged} placeholder="Input the URL path to the stream" />
            </Form.Item>
            {branches.length > 0 && (
                <Form.Item {...formItemLayout} label="Accessible Branches">
                    <Select
                        allowClear
                        mode="multiple"
                        style={{ width: "100%", border: "1.5px solid #ccc", borderRadius: "5px", overflow: "hidden" }}
                        value={accessBranches}
                        onChange={handleAccessBranchesChange}
                        maxTagCount="responsive"
                    >
                        {allBranchesOption && <Option key="all" value="all">All Branches</Option>}
                        {branches.map(b => (
                            <Option key={b.BranchID} value={String(b.BranchID)}>{b.BranchName}</Option>
                        ))}
                    </Select>
                </Form.Item>
            )}
            <Form.Item {...formTailLayout}>
            </Form.Item>
            {/* <Form.Item {...formTailLayout}>
                <Button type="primary" htmlType="submit">
                    {fileData ? "Save" : "Create"}
                </Button>
            </Form.Item> */}

            <Form.Item {...formTailLayout}>
                {
                    errorMessage ? <Alert
                        message="Warning"
                        showIcon
                        description={errorMessage}
                        type="warning"
                        action={
                            <Space direction="vertical">
                                <Button onClick={() => { setErrorMessage(null) }} size="small" danger>
                                    Ignore Warning
                                </Button>
                            </Space>
                        }
                    /> : <Button type="primary" htmlType="submit">
                        {fileData ? "Save" : "Create"}
                    </Button>
                }


            </Form.Item>
        </Form >
    );
};


const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, globalSearch: state.globalSearch, selectedPage: state.selectedPage, selectedBrandData: state.selectedBrandData, selectedBranchData: state.selectedBranchData };
}

export default connect(mapStateToProps, { logout, selectPage, updateGlobalSearch, requestServerPost, requestServerGet })(CreateStreamingURLMediaView);
